
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';

( function( app ) {
  const COMPONENT = {
    init: function() {
      // on change listener for sort select
      $( '#search-sort' ).on( 'change', function( event ) {
        event.preventDefault();
        // get the current url
        const url = new URL( document.location );

        // get the current search params
        const params = url.searchParams;

        // get specific params to check for
        const orderParam = params.get( 'order' );
        const orderbyParam = params.get( 'orderby' );

        // get the current form data
        const formData = new FormData( $( '#sort-search' )[0] );
        const order = formData.get( 'order' );

        // check what we want to search by and check that we are currently not searching by that
        if ( order === 'relevance' && orderbyParam !== '' ) {
          params.delete( 'orderby' );
          params.delete( 'order' );
          url.search = params.toString();
          window.location.href = url;
        } else if ( order === 'title_asc' && orderParam !== 'ASC' ) {
          params.set( 'orderby', 'title' );
          params.set( 'order', 'ASC' );
          url.search = params.toString();
          window.location.href = url;
        } else if ( order === 'title_desc' && orderParam !== 'DESC' ) {
          params.set( 'orderby', 'title' );
          params.set( 'order', 'DESC' );
          url.search = params.toString();
          window.location.href = url;
        } else if ( order === 'date_asc' && orderParam !== 'ASC' ) {
          params.set( 'orderby', 'date' );
          params.set( 'order', 'ASC' );
          url.search = params.toString();
          window.location.href = url;
        } else if ( order === 'date_desc' && orderParam !== 'DESC' ) {
          params.set( 'orderby', 'date' );
          params.set( 'order', 'DESC' );
          url.search = params.toString();
          window.location.href = url;
        }

        return;
      } );
    },
    finalize: function() {

    },
  };
  app.registerComponent( 'search-results', COMPONENT );
} )( app );
